/* eslint-disable react/prop-types */
import { type CardProps, PROP_MAP } from './interface';

import { Devices } from '../../service/Devices';
import { modifyProps } from '../../generators/modifyProps';

export const withLogic =
  (Component: React.ComponentType<CardProps>): React.FC<CardProps> =>
  (userProps: CardProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const hasContentBlockProps = Boolean(
      props.title ||
        props.description ||
        props.primaryCTA ||
        props.secondaryCTA ||
        props.caption
    );
    return (
      <Component
        {...{
          ...props,
          _hasHeaderSlot: Boolean(props.header),
          _hasChildrenSlot: Boolean(props.children),
          _hasContentBlockProps: hasContentBlockProps,
          _hasImageProps: Boolean(props.image),
          _hasContentBlockAndImageProps: Boolean(
            hasContentBlockProps || props.image
          ),
          _platform: Devices.isDesktop() ? 'desktop' : 'mobile',
          children: props.children ? (
            <div style={{ width: '100%' }}>{props.children}</div>
          ) : undefined
        }}
      />
    );
  };

export { CardProps };
